import { MatrixProcessError } from '@/models/matrix-error-response';
import { MatrixProcessMessageType } from '@/models/matrix-process-message-type-enum';
import { MatrixStatusType } from '@/models/matrix-status-enum';
import i18n from '@/plugins/i18n';

export function getControlProcessErrorMessage({ type, message }: MatrixProcessError): string {
  switch (type) {
    case MatrixProcessMessageType.STRUCTURAL:
      return message;
    case MatrixProcessMessageType.CONTROL:
      return i18n.t('notification.matrixProcess.control.controlFailed') as string;
    default:
      return i18n.t('notification.matrixProcess.unknowError') as string;
  }
}

export function getIntegrationProcessErrorMessage({ type, message }: MatrixProcessError): string {
  switch (type) {
    case MatrixProcessMessageType.STRUCTURAL:
      return message;
    case MatrixProcessMessageType.CONTROL:
      return i18n.t('notification.matrixProcess.integration.controlFailed') as string;
    case MatrixProcessMessageType.PARSE:
    case MatrixProcessMessageType.SAVE:
      return i18n.t('notification.matrixProcess.integration.saveOrParseFailed') as string;
    default:
      return i18n.t('notification.matrixProcess.unknowError') as string;
  }
}

export function getMatrixProcessStatusMessage(status: MatrixStatusType, message?: string): string | undefined {
  switch (status) {
    case MatrixStatusType.complete:
      return i18n.t('notification.matrixProcess.integration.success') as string;
    case MatrixStatusType.completeWithAlerts:
      return i18n.t('notification.matrixProcess.integration.successWithAlerts') as string;
    case MatrixStatusType.completeWithRejection:
      return i18n.t('notification.matrixProcess.integration.failureWithRejection') as string;
    case MatrixStatusType.uncomplete:
      return i18n.t('notification.matrixProcess.uncompleteProcess') as string;
    case MatrixStatusType.error:
      return message ?? (i18n.t('notification.matrixProcess.unknowError') as string);
  }
}
